import { pageLayout_children } from "materials/pageLayout/menus/index.js"

export default {
  name: "锚点",
  id: "",
  thumbnail: "icon-portal-menu_anchor",
  type: "cxAnchor",
  enable(params) {
    let detailPageBusinessFlag = true
    if ("detailPageBusinessFlag" in params && params.detailPageBusinessFlag === false) {
      detailPageBusinessFlag = false
    }
    return params.admin && detailPageBusinessFlag
  },
  attribute: pageLayout_children[0].attribute
}
